import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Icons } from '../../../components/atoms/SVG';
import { appendModifiers } from '../../../lib/bemUtils/Modifier';
import { StatusInfo, StatusInfoModifier } from './partials/StatusInfo';
import { Content } from './partials/Content';
import { Message } from './partials/Message';
import { Icon } from './partials/Icon';

type StatusInfoError = {
  modifier?: StatusInfoModifier;
  message?: string | React.ReactNode;
};

/**
 * Error with role alert which will notify screen readers.
 *
 * valid Usage:
 *  - User caused error which can be fixed by user.
 */
export function StatusInfoError({ modifier, message }: StatusInfoError) {
  const { t } = useSonTranslation('ErrorInfo');

  return (
    <StatusInfo modifier={appendModifiers(modifier, 'red')} role="alert">
      <Content>
        <Icon icon={Icons.FEEDBACK_ERROR} />
        <Message>{message || t('serverError.text')}</Message>
      </Content>
    </StatusInfo>
  );
}
